import { ApplicationPaneHeader } from './../../atoms/applications/ApplicationPaneHeader';
import * as React from 'react';
import { observer, inject } from 'mobx-react';
import './applicationPageUserInfoPane.module.scss';
import { Page, Pane, PaneBody } from '../../atoms/applications/page';
import { Loader } from '../../atoms/forms/loader';
import { UserForm } from '../../molecules/applications/UserForm';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import { routingStore } from '../../../../common/stores/routing';
import { V3Routes } from '../../../routes';
import { BaseApplicationPageState } from '../../../containers/application/states/BaseApplicationPageState';

type Props = {
    applicationState: BaseApplicationPageState;
    nextButtonLabel?: string;
};

@inject('applicationState')
@observer
export class ApplicationPageUserInfoPane extends React.Component<Props> {
    render() {
        const {
            applicationState: {
                applicationPageResource,
                userFormState,
                validateUserAndNext,
                name,
                page_key,
                submitState: { submitting },
            },
            nextButtonLabel,
        } = this.props;
        if (applicationPageResource.loading) {
            return <Loader />;
        }
        return (
            <Page>
                <Pane styleName="pane">
                    <PaneBody>
                        <ApplicationPaneHeader plan={name} />
                        <div styleName="container">
                            <div styleName="heading">アカウントをお持ちの方</div>
                            <div styleName="subheading center">(過去に体験レッスンを受けた方)</div>
                            <Button
                                type="primary"
                                size="l"
                                styleName="button"
                                onClick={() => routingStore.push(V3Routes.applicationPageSignIn(page_key))}
                            >
                                ログインする
                            </Button>
                            <div styleName="explanation">
                                <strong>ログインをすると</strong>
                                ・フォームの項目が一部自動入力されます。<br />
                                ・当日入会キャンペーン等の適応がされます
                            </div>
                        </div>
                        <hr />
                        <div styleName="container">
                            <div styleName="heading">アカウントをお持ちでない方</div>
                            <div styleName="subheading">
                                新しくアカウントを作成いたしますのでこちらの<br />フォームに入力をお願いします。
                            </div>
                        </div>
                        <UserForm
                            submitting={submitting}
                            state={userFormState}
                            onSubmit={validateUserAndNext}
                            buttonLabel={nextButtonLabel || 'プラン内容の確認へ'}
                            showPasswordFields={true}
                        />
                    </PaneBody>
                </Pane>
            </Page>
        );
    }
}
